import _ from 'lodash'

export const STRIPE_PLANS = [
  {
    name: 'Starter',
    maxCustomers: 100,
    title: 'Starter (1–100 Customers)',
    monthlyPriceId: 'price_1UIXcV2Kelwl8r8rRvwL0SvO',
    annualPriceId: 'price_1UIXZP2Kelwl8r8rWA4R8nPn',
    monthlyAmount: 25,
    annualAmount: 300,
  },
  {
    name: 'Basic',
    maxCustomers: 250,
    title: 'Basic (101–250 Customers)',
    monthlyPriceId: 'price_1UIXc12Kelwl8r8rjdGkcQWw',
    annualPriceId: 'price_1UIXXo2Kelwl8r8rFy822EnG',
    monthlyAmount: 42,
    annualAmount: 500,
  },
  {
    name: 'Standard',
    maxCustomers: 500,
    title: 'Standard (251–500 Customers)',
    monthlyPriceId: 'price_1UIXba2Kelwl8r8rkqh6DeiG',
    annualPriceId: 'price_1UIXVo2Kelwl8r8rts0spyQe',
    monthlyAmount: 58,
    annualAmount: 700,
  },
  {
    name: 'Pro',
    maxCustomers: 750,
    title: 'Pro (501–750 Customers)',
    monthlyPriceId: 'price_1UIXat2Kelwl8r8rpIK0VcjX',
    annualPriceId: 'price_1UIXUJ2Kelwl8r8roRzVctxe',
    monthlyAmount: 75,
    annualAmount: 900,
  },
  {
    name: 'Enterprise',
    maxCustomers: 1000,
    title: 'Enterprise (751–1000 Customers)',
    monthlyPriceId: 'price_1UIXaP2Kelwl8r8rSd6JPxcQ',
    annualPriceId: 'price_1UIXHR2Kelwl8r8r9FpsiSGv',
    monthlyAmount: 92,
    annualAmount: 1100,
  },
]

// Sandbox prices, retired when the live Stripe account went into service. Kept so
// accounts that subscribed during the test period keep resolving to their tier.
const SANDBOX_PRICE_TO_MAX = {
  price_1TdjZ2RszYDo0JN3vurdGjZL: 100,
  price_1Tdjl1RszYDo0JN3qNcz65Av: 100,
  price_1TdjaZRszYDo0JN3j5UQhbim: 250,
  price_1TdjlZRszYDo0JN3NVfCeuHY: 250,
  price_1TdjbMRszYDo0JN3Ccfcy7VJ: 500,
  price_1Tdjm2RszYDo0JN3YeztZvPw: 500,
  price_1Tdjc5RszYDo0JN3If5JVo8h: 750,
  price_1TdjmORszYDo0JN3RzOjF3IP: 750,
  price_1Tdjd3RszYDo0JN33w0k7afY: 1000,
  price_1TdjmlRszYDo0JN3EI8qohvp: 1000,
}

const LEGACY_PRICE_TO_MAX = {
  price_1LpZZ9D7TGVtVh1bzVkMRNdT: 100,
  price_1JOpVpD7TGVtVh1baI2UpCN6: 100,
  price_1LpZbYD7TGVtVh1bz0kbOAxY: 100,
  price_1LqDcPD7TGVtVh1bfA4p80tj: 250,
  price_1LqDcPD7TGVtVh1bEbCyO4wv: 250,
  price_1LqDinD7TGVtVh1bAEZBh5SO: 500,
  price_1LqDj7D7TGVtVh1b49zbJFzl: 500,
  price_1JOpX8D7TGVtVh1bHfm2p6kX: 500,
  price_1LqDkZD7TGVtVh1bO5sLies2: 750,
  price_1LqDklD7TGVtVh1bTHYOfJpA: 750,
  price_1LqDlpD7TGVtVh1bnL0Bdn0o: 1000,
  price_1LqDm3D7TGVtVh1bcQKQFdQd: 1000,
  price_1Mb4XGD7TGVtVh1bRdiOVhqq: 5,
}

export function resolveMaxCustomersFromPriceId(priceId) {
  const plan = STRIPE_PLANS.find(
    (entry) => entry.monthlyPriceId === priceId || entry.annualPriceId === priceId
  )
  if (plan) {
    return plan.maxCustomers
  }
  return SANDBOX_PRICE_TO_MAX[priceId] || LEGACY_PRICE_TO_MAX[priceId] || 0
}

export function parseSubscriptionLimits(subscriptions) {
  let maxCustomers = 0
  let stripeAccountExists = false

  _.forEach(subscriptions, (subscription) => {
    if (!subscription.plan || !subscription.plan.active) {
      return
    }

    const tierMax = resolveMaxCustomersFromPriceId(subscription.plan.id)
    if (tierMax > 0) {
      stripeAccountExists = true
      maxCustomers = Math.max(maxCustomers, tierMax)
    }
  })

  return { maxCustomers, stripeAccountExists }
}

export function getPriceIdForPlan(plan, billingInterval) {
  return billingInterval === 'year' ? plan.annualPriceId : plan.monthlyPriceId
}
